import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BrainstormListPage } from './brainstorm-list';

@NgModule({
  declarations: [
    BrainstormListPage,
  ],
  imports: [
    IonicPageModule.forChild(BrainstormListPage),
  ],
})
export class BrainstormListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/brainstorm-list/brainstorm-list.module.ts